import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TchekOldService } from '../../service/tchek-old.service';
import { SearchService } from '../../service/search.service';
import { Tchek } from '../../model/tchek';
import { ParseFunctionService } from '../../service/parsefunction.service';
import { DamageService } from '../../service/damage.service';

declare const $: any;

@Component({
  selector: 'app-comparison-modal',
  templateUrl: './comparison-modal.component.html',
  styleUrls: ['./comparison-modal.component.less']
})
export class ComparisonModalComponent implements OnInit, OnChanges {
  @Input() vehicleId: string;
  @Input() tchekId: string;
  @Input() button: string;
  @Output() onTchekSelected: EventEmitter<string>;
  tcheks: Array<any>;
  previousScan: any = undefined
  private chosenTchek: any;

  constructor(
    private _modalService: NgbModal,
    private _tchekService: TchekOldService,
    private _searchService: SearchService,
    private _parseFunction: ParseFunctionService,
    private _damageService: DamageService
  ) {
    this.tcheks = [];
    this.onTchekSelected = new EventEmitter<string>();
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  ngOnInit() {
    if (!this.vehicleId)
      return;
    /*
    // This request takes 7-14s and is totally dumb !!!
    this._tchekService.getTcheksByVehicleId(this.vehicleId).then((allTcheks: Array<any>) => {
      this.tcheks = [];
      for (let i = 0; i < allTcheks.length; i++) {
        if (allTcheks[i].id !== this.tchekId)
          this.tcheks.push(this._parseFunction.getTcheks(allTcheks[i]));
      }

      let index = allTcheks.findIndex(t => { return t.id === this.tchekId })
      if (index > -1 && allTcheks[index + 1])
        this.previousScan = allTcheks[index + 1]
    });*/

    // this request takes 200ms
    this._searchService.getPreviousTchek(this.tchekId,this.vehicleId).then((previousTchek: any) => {
      this.tcheks = [];
      this.tcheks.push(this._parseFunction.getTcheks(previousTchek));
      this.previousScan = previousTchek;
    });
  }

  openComparisonModal(content) {
    this._modalService.open(content).result.then((modalData) => {
      // this.closeResult = `Closed with: ${result}`;
      // console.log('final data :', this.chosenTchek);
      this._damageService.setComparison(true)
      this.onTchekSelected.emit(this.chosenTchek.id);
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openComparisonLastScan() {
    this.chosenTchek = this.previousScan
    this.onTchekSelected.emit(this.chosenTchek.id);
    this._damageService.setComparison(true)
  }

  toggleCheckbox(event, tchek): void {
    if (event.target.checked) {
      this.chosenTchek = tchek;
    } else {
      this.chosenTchek = undefined;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/element/comparison-modal/comparison-modal.component.ts